import styles from "./CartButtonSecondary.module.css"
import { ShoppingCart } from 'lucide-react';

/**
* Props for the CartButtonSecondary component.
*/ 
interface CartButtonSecondaryProps{
    text?:string, // Button label
    onClick?: ()=>void, // Click event handler
    className?:string, // Optional additional class
    colorVariant?: string, // Color variant
    disabled?: boolean // Disable the button
}
/**
* A button for adding products into cart.
*
* @param props CartButtonSecondary props
* @param {string} props.colorVariant - Color variant
* @param {string} props.text - Button label
* @param {boolean} props.disabled - Disable the button
* @param {string} props.className - Optional additional class
* @param {() => void} props.onClick - Function to call on click.
* @returns TSX.Element
*/
const CartButtonSecondary = ({text, onClick, className, colorVariant , disabled = false} : CartButtonSecondaryProps) => {

    return(
        <>
            <button 
            className={`${styles.CartButtonSecondary}  ${className ?? ''} ${colorVariant == "secondary" ? styles.Secondary : ""} ${colorVariant == "primary" ? styles.Primary : ""} ${colorVariant == "neutral" ? styles.Neutral : ""} ${disabled ? styles.Disabled : ''}`}
            onClick={() => onClick && onClick()}
            disabled={disabled}>
                {text &&
                <div className={styles.CartButtonSecondaryText}>
                    <p>{text}</p>
                </div>
                }
                <div className={styles.CartButtonSecondaryIcon}>
                    <ShoppingCart />
                </div>
            </button>
        </>
    )
}
export default CartButtonSecondary